import { ThemeOptions, createTheme } from '@material-ui/core';
import { LightThemeContextBackgrounds, LightThemeOptions } from './LightTheme';

const DarkThemeOptions: ThemeOptions = {
    ...LightThemeOptions,
    palette: {
        contextBackgrounds: LightThemeContextBackgrounds,
        error: {
            main: '#ffa7a5',
        },
        info: {
            main: '#96b4f7',
        },
        neutral: {
            main: '#323232',
        },
        primary: {
            main: '#b597fc',
        },
        secondary: {
            main: '#ffbbea',
        },
        success: {
            main: '#83b4b5',
        },
        type: 'dark',
        warning: {
            main: '#fae7a3',
        },
    },
};

export const DarkTheme = createTheme(DarkThemeOptions);
